import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  beginCommandDispatch,
  endCommandDispatch,
  promoteCommandDispatch,
  runSiteCommandWrite,
  selectSiteCommandLocked,
} from '@sophocles/features/entities/site';

/** Run configuration writes through the same site-scoped command lease as launchers. */
export default function useSiteCommandWrite(siteId) {
  const dispatch = useDispatch();
  const commandLocked = useSelector(selectSiteCommandLocked(siteId));

  const runWrite = useCallback(
    (write, { requiresCommand = false, pendingCount = 1 } = {}) =>
      runSiteCommandWrite({
        requiresCommand,
        begin: () => dispatch(beginCommandDispatch({ siteId })),
        promote: (requestId, count) => dispatch(promoteCommandDispatch({ siteId, requestId, pendingCount: count })),
        end: requestId => dispatch(endCommandDispatch({ siteId, requestId })),
        write,
        pendingCount,
      }),
    [dispatch, siteId],
  );

  return useMemo(() => ({ commandLocked, runWrite }), [commandLocked, runWrite]);
}
